var map = {
	"./config.development": "1cc2",
	"./config.development.js": "1cc2",
	"./config.global": "a5ad",
	"./config.global.js": "a5ad",
	"./config.production": "6a89",
	"./config.production.js": "6a89",
	"./config.test": "3d43",
	"./config.test.js": "3d43"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f82";